const parseText = ({ text, limit }) =>
  text.length > limit ? `${text.substr(0, limit)}...` : text;

export { parseText };
